/**
 * Generated API paths already include `/api/...`.
 * Strip a trailing `/api` from VITE_API_URL so axios does not produce `/api/api/...`.
 */
export const resolveApiBaseUrl = (url?: string) => {
  if (!url?.trim()) {
    return undefined;
  }

  return url.replace(/\/api\/?$/, "").replace(/\/$/, "");
};
